// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"f475da5f","977":"098a444f"}[chunkId] + ".chunk.js";
};